import { Badge, type BadgeProps } from "@/components/ui/badge";

type StatusValue =
  | "draft"
  | "active"
  | "paused"
  | "preparing"
  | "ready"
  | "needs_attention"
  | "error"
  | "pending"
  | "running"
  | "queued"
  | "succeeded"
  | "failed"
  | "timed_out"
  | "lost"
  | "cancelled"
  | "canceled"
  | "approved"
  | "rejected"
  | "expired"
  | "applied"
  | "healthy"
  | "degraded";

const STATUS_VARIANT: Record<StatusValue, BadgeProps["variant"]> = {
  draft: "draft",
  active: "active",
  paused: "paused",
  preparing: "pending",
  ready: "active",
  needs_attention: "error",
  error: "error",
  pending: "pending",
  queued: "pending",
  running: "running",
  succeeded: "succeeded",
  failed: "failed",
  timed_out: "failed",
  lost: "failed",
  cancelled: "draft",
  canceled: "draft",
  approved: "succeeded",
  rejected: "failed",
  expired: "draft",
  applied: "succeeded",
  healthy: "active",
  degraded: "paused",
};

export function StatusBadge({ status }: { status: string }) {
  const variant = STATUS_VARIANT[status as StatusValue] ?? "secondary";
  return <Badge variant={variant}>{status.replace(/_/g, " ")}</Badge>;
}
